<div class="d-flex flex-column">
  <ng-container *ngIf="availableServiceProviders.length > 0">
    <p
      [innerHTML]="
        'inquiry.inquiredServiceProvidersModal.providersReceivedPlaceholder'
          | translate: { providersAmount: amountOfSentServiceProviders }
      "
    ></p>
    <div class="d-flex justify-content-between align-items-center">
      <base-search
        class="fb-60"
        placeholder="inquiry.inquiredServiceProvidersModal.searchPlaceholder"
        [value]="searchQuery"
        (query)="filterAvailableServiceProviders($event)"
      ></base-search>
      <base-button
        *ngIf="!isInquiryClosed"
        [disabled]="isSendButtonDisabled"
        color="dark"
        label="action.sendImmediately"
        (btnClick)="sendImmediately()"
      ></base-button>
    </div>
  </ng-container>

  <div class="listview container-fluid">
    <div class="listview-header">
      <div class="row w-100">
        <div class="col-6 d-flex align-items-center">
          <base-checkbox
            [isDisabled]="isSelectAllCheckboxDisabled"
            [isChecked]="areAllProvidersSelected"
            (getChange)="selectAllProviders($event)"
          ></base-checkbox>
          <base-sortable-headline-item
            class="d-block ms-7"
            [label]="('branch.linked' | translate) + ' | ' + ('providerShort' | translate)"
            orderKey="pspBranch"
            [clientSide]="true"
            (sortChange)="sortAvailableServiceProviders($event)"
          ></base-sortable-headline-item>
        </div>
        <div class="col-2">
          <base-sortable-headline-item
            class="d-block"
            label="deliveryPriority"
            orderKey="priority"
            [clientSide]="true"
            (sortChange)="sortAvailableServiceProviders($event)"
          ></base-sortable-headline-item>
        </div>
        <div class="col-2">
          {{ 'zipCity' | translate }}
        </div>
        <div class="col-2">
          <base-sortable-headline-item
            class="d-block"
            label="tooltip.sendingTime"
            orderKey="sendingTime"
            [clientSide]="true"
            (sortChange)="sortAvailableServiceProviders($event)"
          ></base-sortable-headline-item>
        </div>
      </div>
    </div>

    <div class="overflow-modal-content">
      <ng-container *ngFor="let item of availableServiceProvidersFiltered; let i = index; let last = last">
        <base-customer-inquired-service-provider-list-item
          [providerInfo]="item"
          [isInquiryClosed]="isInquiryClosed"
          (itemSelect)="toggleProviderSelection($event)"
        ></base-customer-inquired-service-provider-list-item>
        <hr *ngIf="i === amountOfInquiredServiceProviders - 1 && !last" />
      </ng-container>

      <base-empty-list-row
        *ngIf="availableServiceProviders.length === 0 || availableServiceProvidersFiltered.length === 0"
        [backgroundSecondary]="true"
        message="providers.emptyList"
      ></base-empty-list-row>
    </div>
  </div>
</div>
